import { jsx, css } from '@emotion/react';
import _ from 'lodash';

import { connectLocation } from '../../location/LocationConnectors';

const currentLocale = document.querySelector('html').getAttribute('lang');

const priceBadge = css`
  background-color: black;
  border-radius: 15px;
  padding: 4px 4px 1px 4px;
  color: #959595;
  margin-left: 10px;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 1.5px;
  position: relative;
  bottom: 5px;
`;

function PriceRange({ uid, t }) {
  if (!uid) return null;
  if (currentLocale.toLocaleLowerCase() === 'fr-ca' || currentLocale.toLocaleLowerCase() === 'en-ca') return null;

  const parts = t('shingles.price_ranges')[uid - 1].split(' - ');
  const name = parts[parts.length - 1];

  return (
    <span css={priceBadge} role="img" aria-label={`${name} ${t('shingles.price_range')}`}>
      {_.range(1, 6).map(n => {
        const style = n <= uid ? { color: 'white' } : null;
        return (
          <span key={n} style={style} aria-hidden="true">
            &#36;
          </span>
        );
      })}
    </span>
  );
}

export default connectLocation(PriceRange);
